import { Box, InfoIcon, Text } from '@wix/design-system';
import React, { useContext } from 'react';

import { RicosContext, ZIndexContext } from './../../../ricos-context';
import type { PmHtmlNode } from './../../../_shared/pm-node-types';
import { usePanelContainerElement } from './../../../ui-components';

import { HtmlInputArea } from './HtmlInputArea';

export type AdsenseSourceInputProps = {
  htmlNodeAttrs?: Partial<PmHtmlNode['attrs']>;
  onHtmlInputChange?: (html: string) => void;
};

export const AdsenseSourceInput: React.FC<AdsenseSourceInputProps> = ({
  htmlNodeAttrs,
  onHtmlInputChange,
}) => {
  const { t } = useContext(RicosContext);
  const zIndexService = useContext(ZIndexContext);
  const containerEl = usePanelContainerElement();

  return (
    <Box direction="vertical" gap="SP3">
      <Box verticalAlign="middle" gap="SP1">
        <Text size="small">{t('HtmlEditPanel_HtmlInput_AdSense_Title')} </Text>
        <InfoIcon
          size="small"
          content={t('HtmlEditPanel_HtmlInput_AdSense_Tooltip')}
          tooltipProps={{
            appendTo: containerEl,
            zIndex: zIndexService.getZIndex('TOOLTIP'),
          }}
        />
      </Box>
      <HtmlInputArea
        value={htmlNodeAttrs?.html ?? ''}
        onChange={(value: string) => {
          onHtmlInputChange?.(value);
        }}
        placeholder={t('HtmlEditPanel_HtmlInput_AdSense_Placeholder')}
      />
    </Box>
  );
};
